const getNestedValue = (obj, path) => {
  if (!path) return ''
  return path.split('.').reduce((acc, part) => acc && acc[part], obj)
}

export const tableConfig = {
  groups: [
    {
      key: 'plantao',
      title: 'Plantão',
      columns: [
        { key: 'plantao.id', header: 'ID' },
        { key: 'plantao.data', header: 'Data' },
        { key: 'plantao.fuso', header: 'Fuso Horário' }
      ]
    },
    {
      key: 'empresa',
      title: 'Empresa',
      columns: [
        { key: 'empresa.id', header: 'ID' },
        { key: 'empresa.nome', header: 'Nome' },
        { key: 'empresa.cnpj', header: 'CNPJ' }
      ]
    },
    {
      key: 'unidade',
      title: 'Unidade',
      columns: [
        { key: 'unidade.id', header: 'ID' },
        { key: 'unidade.nome', header: 'Nome' },
        { key: 'unidade.endereco', header: 'Endereço' },
        { key: 'unidade.cidade', header: 'Cidade' },
        { key: 'unidade.uf', header: 'UF' },
        { key: 'unidade.grupoOperacional', header: 'Grupo Operacional' }
      ]
    },
    {
      key: 'escala',
      title: 'Escala',
      columns: [
        { key: 'escala.id', header: 'ID' },
        { key: 'escala.nome', header: 'Nome' },
        { key: 'escala.grupoOperacional', header: 'Grupo Operacional' }
      ]
    },
    {
      key: 'posicao',
      title: 'Posição',
      columns: [
        { key: 'posicao.id', header: 'ID' },
        { key: 'posicao.nome', header: 'Nome' }
      ]
    },
    {
      key: 'turno',
      title: 'Turno',
      columns: [
        { key: 'turno.id', header: 'ID' },
        { key: 'turno.nome', header: 'Nome' }
      ]
    },
    {
      key: 'medico',
      title: 'Médico',
      columns: [
        { key: 'medico.id', header: 'ID' },
        { key: 'medico.nome', header: 'Nome' },
        { key: 'medico.crm', header: 'CRM' },
        { key: 'medico.crmUf', header: 'CRM UF' },
        { key: 'medico.email', header: 'Email' },
        { key: 'medico.telefone', header: 'Telefone' },
        { key: 'medico.cpf', header: 'CPF' },
        { key: 'medico.equipe', header: 'Equipe' }
      ]
    },
    {
      key: 'autorizacao',
      title: 'Médico Autorizador',
      columns: [
        { key: 'autorizador.id', header: 'ID' },
        { key: 'autorizador.nome', header: 'Nome' },
        { key: 'autorizador.email', header: 'Email' }
      ]
    },
    {
      key: 'antecipe',
      title: 'Antecipe',
      columns: [
        { key: 'antecipe.solicitada', header: 'Antecipação Solicitada' },
        { key: 'antecipe.paga', header: 'Antecipação Paga' },
        { key: 'antecipe.dataSolicitacao', header: 'Data Solicitação' },
        { key: 'antecipe.dataPagamento', header: 'Data Pagamento' }
      ]
    },
    {
      key: 'statusVaga',
      title: 'Status da Vaga',
      columns: [
        { key: 'statusVaga.checado', header: 'Plantão Checado' },
        { key: 'statusVaga.termoAceito', header: 'Termo Aceito' },
        { key: 'statusVaga.aberta', header: 'Vaga Aberta' },
        { key: 'statusVaga.cobertura', header: 'Status da Cobertura', requiresCoverage: true },
        {
          key: 'statusVaga.responsavel',
          header: 'Responsável pela Cobertura',
          requiresCoverage: true
        },
        { key: 'statusVaga.createdAt', header: 'Created At' },
        { key: 'statusVaga.updatedAt', header: 'Updated At' }
      ]
    },
    {
      key: 'alocacao',
      title: 'Alocação',
      columns: [
        { key: 'alocacao.data', header: 'Data Alocação' },
        { key: 'alocacao.alocador.id', header: 'ID Alocador' },
        { key: 'alocacao.alocador.nome', header: 'Nome Alocador' },
        { key: 'alocacao.alocador.email', header: 'Email Alocador' }
      ]
    },
    {
      key: 'aVista',
      title: 'Pagamento à Vista',
      columns: [
        { key: 'aVista.isVista', header: 'É à Vista?' },
        { key: 'aVista.dataSolicitacao', header: 'Data Solicitação' },
        { key: 'aVista.liberador.id', header: 'ID Liberador' },
        { key: 'aVista.liberador.nome', header: 'Nome Liberador' },
        { key: 'aVista.liberador.email', header: 'Email Liberador' }
      ]
    },
    {
      key: 'politica',
      title: 'Política de Pagamento',
      columns: [
        { key: 'politica.id', header: 'ID Política' },
        { key: 'politica.nome', header: 'Nome Política' },
        { key: 'politica.inicioVigencia', header: 'Início Vigência' },
        { key: 'politica.fimVigencia', header: 'Fim Vigência' },
        { key: 'politica.vinculador.id', header: 'ID Vinculador' },
        { key: 'politica.vinculador.nome', header: 'Nome Vinculador' },
        { key: 'politica.vinculador.email', header: 'Email Vinculador' }
      ]
    },
    {
      key: 'excepcionalidade',
      title: 'Excepcionalidade',
      columns: [
        { key: 'excepcionalidade.isExcepcionalidade', header: 'É Excepcionalidade?' },
        { key: 'excepcionalidade.id', header: 'ID Excepcionalidade' },
        { key: 'excepcionalidade.solicitante.id', header: 'ID Solicitante' },
        { key: 'excepcionalidade.solicitante.nome', header: 'Nome Solicitante' },
        { key: 'excepcionalidade.solicitante.email', header: 'Email Solicitante' },
        { key: 'excepcionalidade.aprovador.id', header: 'ID Aprovador' },
        { key: 'excepcionalidade.aprovador.nome', header: 'Nome Aprovador' },
        { key: 'excepcionalidade.aprovador.email', header: 'Email Aprovador' }
      ]
    },
    {
      key: 'dadosAssumidos',
      title: 'Dados Assumidos do Plantão',
      columns: [
        { key: 'dadosAssumidos.valor', header: 'Valor Plantão' },
        {
          key: 'dadosAssumidos.valorReferencia',
          header: 'Valor de Referência',
          requiresCoverage: true
        },
        { key: 'dadosAssumidos.jornada', header: 'Jornada' },
        { key: 'dadosAssumidos.modalidade', header: 'Modalidade Repasse' },
        { key: 'dadosAssumidos.regra', header: 'Regra Proporcionalidade' }
      ]
    },
    {
      key: 'check',
      title: 'Checks',
      columns: [
        { key: 'check.metodo', header: 'Método' },
        { key: 'check.checkin.data', header: 'Data Check-in' },
        { key: 'check.checkin.horario', header: 'Horário Check-in' },
        { key: 'check.checkin.latitude', header: 'Latitude Check-in' },
        { key: 'check.checkin.longitude', header: 'Longitude Check-in' },
        { key: 'check.checkin.distancia', header: 'Distância Check-in' },
        { key: 'check.checkin.link', header: 'Link Check-in' },
        { key: 'check.checkout.data', header: 'Data Check-out' },
        { key: 'check.checkout.horario', header: 'Horário Check-out' },
        { key: 'check.checkout.latitude', header: 'Latitude Check-out' },
        { key: 'check.checkout.longitude', header: 'Longitude Check-out' },
        { key: 'check.checkout.distancia', header: 'Distância Check-out' },
        { key: 'check.checkout.link', header: 'Link Check-out' },
        { key: 'check.status', header: 'Status Checks' },
        { key: 'check.verificacao', header: 'Verificação' }
      ]
    },
    {
      key: 'pagamentoFinal',
      title: 'Pagamento Final',
      columns: [
        { key: 'pagamentoFinal.valorAPagar', header: 'Valor a Pagar' },
        { key: 'pagamentoFinal.observacoes', header: 'Observações' }
      ]
    }
  ],
  getNestedValue
}
